export const contactMessagesData = [
  {
    key: "1",
    FROM: "Andrew Simons",
    IMAGE: "avatar-20.jpg",
    PHONE: "+1 555 123 4567",
    EMAIL: "andrew@example.com",
    CREATEDDATE: "24 Jan 2025",
    MESSAGE: ""
  },
  {
    key: "2",
    FROM: "David Steiger",
    IMAGE: "avatar-21.jpg",
    PHONE: "+44 7911 123456",
    EMAIL: "david@example.com",
    CREATEDDATE: "19 Dec 2024",
    MESSAGE: ""
  },
  {
    key: "3",
    FROM: "Virginia Phu",
    IMAGE: "avatar-12.jpg",
    PHONE: "+33 612 345678",
    EMAIL: "phu@example.com",
    CREATEDDATE: "11 Dec 2024",
    MESSAGE: ""
  },
  {
    key: "4",
    FROM: "Walter Hartmann",
    IMAGE: "avatar-22.jpg",
    PHONE: "+61 412 345 678",
    EMAIL: "walter@example.com",
    CREATEDDATE: "29 Nov 2024",
    MESSAGE: ""
  },
  {
    key: "5",
    FROM: "Andrea Jermaine",
    IMAGE: "avatar-27.jpg",
    PHONE: "+91 98765 43210",
    EMAIL: "jermaine@example.com",
    CREATEDDATE: "03 Nov 2024",
    MESSAGE: ""
  },
  {
    key: "6",
    FROM: "Dennis Eckhardt",
    IMAGE: "avatar-05.jpg",
    PHONE: "+49 171 2345678",
    EMAIL: "dennis@example.com",
    CREATEDDATE: "31 Oct 2024",
    MESSAGE: ""
  },
  {
    key: "7",
    FROM: "Lan Adams",
    IMAGE: "avatar-25.jpg",
    PHONE: "+81 90 1234 5678",
    EMAIL: "lan@example.com",
    CREATEDDATE: "15 Oct 2024",
    MESSAGE: ""
  },
  {
    key: "8",
    FROM: "Ann Crump",
    IMAGE: "avatar-28.jpg",
    PHONE: "+34 612 345678",
    EMAIL: "crump@example.com",
    CREATEDDATE: "26 Sep 2024",
    MESSAGE: ""
  },
  {
    key: "9",
    FROM: "Julie Black",
    IMAGE: "avatar-07.jpg",
    PHONE: "+55 1987654321",
    EMAIL: "julie@example.com",
    CREATEDDATE: "01 Sep 2024",
    MESSAGE: ""
  },
  {
    key: "10",
    FROM: "Jean Walker",
    IMAGE: "avatar-29.jpg",
    PHONE: "+27 82 12364567",
    EMAIL: "jean@example.com",
    CREATEDDATE: "15 Aug 2024",
    MESSAGE: ""
  },
];
